import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { FormGroup } from '@angular/forms';

export const applicationServerPublicKey = 'BEiyjIvUUCy--e-qe2qAEMfwpJrrfxPpx7s6yM0jCVNdIOhgXVociug_Yo2hov8RZCBNpzvfHdxlmGJ3Ptra1D8';
export const EMAIL_PATTERN = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
export const URL_SERVICIOS = `${environment.baseUrl}/api/`;
export const HTTP_OPTIONS = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 60;
export const TIMER_SET_INTERVAL = 300000;
export const TIMER_BELL_NOTIFICATIONS = 10000;

export const DataTableEsp = {
    sProcessing: 'Procesando...',
    sLengthMenu: 'Mostrar _MENU_ registros',
    sZeroRecords: 'No se encontraron resultados',
    sEmptyTable: 'No hay registro(s) disponible(s)',
    sInfo: 'Mostrando registros del <b> _START_ </b>al<b> _END_ </b>de un total de<b> _TOTAL_ </b>registros',
    sInfoEmpty: 'Mostrando registros del<b> 0 </b>al<b> 0 </b>de un total de<b> 0 </b>registros',
    sInfoFiltered: '(filtrado de un total de<b> _MAX_ </b>registros)',
    sInfoPostFix: '',
    sSearch: 'Buscar:',
    sUrl: '',
    sInfoThousands: ',',
    sLoadingRecords: 'Cargando...',
    oPaginate: {
        sFirst: 'Primero',
        sLast: 'Último',
        sNext: 'Siguiente',
        sPrevious: 'Anterior'
    },
    oAria: {
        sSortAscending: ': Activar para ordenar la columna de manera ascendente',
        sSortDescending: ': Activar para ordenar la columna de manera descendente'
    },
};

export const FASES = [
    { title: 'Introducción', number: 1, icon: ['fas', 'share'] },
    { title: 'Selección' , number: 2, icon: ['far', 'folder'] },
    { title: 'Cotización', number: 3, icon: ['fas', 'briefcase'] },
    { title: 'Autorización', number: 4, icon: ['far', 'edit'] },
    { title: 'Validación', number: 5, icon: ['far', 'file'] },
    { title: 'Entrega', number: 6, icon: ['fas', 'user-friends'] }
]

export const FERIADOS_COLOMBIA = [
    {"day": 1, "month": 1},
    {"day": 9, "month": 1},
    {"day": 20, "month": 3},
    {"day": 6, "month": 4},
    {"day": 7, "month": 4},
    {"day": 9, "month": 4},
    {"day": 1, "month": 5},
    {"day": 22, "month": 5},
    {"day": 12, "month": 6},
    {"day": 19, "month": 6},
    {"day": 3, "month": 7},
    {"day": 20, "month": 7},
    {"day": 7, "month": 8},
    {"day": 21, "month": 8},
    {"day": 16, "month":10},
    {"day":6,"month":11},
    {"day":13,"month":11},
     {"day":8,"month":12},
     {"day":25,"month":12}
  ]

/**
 * Convierte valor de campos string a numero, en caso de float usa todos los decimales
 * @param data      valor a convertir
 * @param toFloat   true si requiere decimal
 * @returns         valor convertido de acuerdo a @param toFloat
 */
 export const getValueSum = (data: any, toFloat = false) => data ? (toFloat ? parseFloat(data) : parseInt(data, 0)) : 0;

/**
 * Convierte valor de campos string a numero, en caso de float usa 2 por defecto
 * @param data      valor a convertir
 * @param toFloat   true si requiere decimales
 * @param d         cantidad de decimales, si @param toFloat es true
 * @returns
 */
export const getNumberConvert = (data: any, toFloat: boolean = false, d: number = 2) => data ? (toFloat ? parseFloat(parseFloat(data).toFixed(d)) : parseInt(data, 0)) : 0;

/**
 * Hace un parse de la data JSON (util para los select multiples)
 * @param conv      tipo de conversion 's' para comver a string 'p' para convertir a objeto
 * @param data      data a convertir
 * @returns         resultado de acuerto a @param conv
 */
export const getJsonConvert = (conv: string, data: any) => data ? (conv === 's' ? JSON.stringify(data) : JSON.parse(data)) : null;

/**
 * Validar que el valor de @param event sea un numero
 * @param event     KeyboardEvent
 * @returns
 */
 export const soloNumero = (event: KeyboardEvent) => event.charCode >= 48 && event.charCode <= 57 ? null : event.preventDefault();

 /**
  * Validar que el valor de @param event sea un numero decimal
  * @param event     KeyboardEvent
  * @returns
  */
 export const soloNumeroPunto = (event: KeyboardEvent) => event.charCode >= 48 && event.charCode <= 57 || event.charCode === 13 ? null : event.preventDefault();

 export const DAYS = [
    { name: 'Lunes', valueId: 'L' },
    { name: 'Martes', valueId: 'M' },
    { name: 'Miércoles', valueId: 'I' },
    { name: 'Jueves', valueId: 'J' },
    { name: 'Viernes', valueId: 'V' },
    { name: 'Sábado', valueId: 'S' },
    { name: 'Domingo', valueId: 'D' }
]

export enum status {
    InProcess = "En proceso",
    Approved = "Aprobado",
    Completed = "Completado",
    Postponed = "En espera",
    Closed = "Cerrado",
    Rejected = "Negado",
    NoAdjud = "No adjudicado"
}

/**
  * Verifica si el formulario es válido o no
  * @param form
  * @returns
  */
export const isValidForm = (form: FormGroup) => {
    let valid = true;
    Object.values(form.controls).forEach(x => {
        if(x?.status === "INVALID") {
            valid = false;
            return;
        }
    });

    return valid;
};
